import {useMutation} from "@apollo/client";
import {useState} from "react";
import {FiTrash2} from "react-icons/fi";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {ButtonAction} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {GQL_DELETE_TAGS, GQL_SERVICE_TAGS} from "@/lib/queries/checks.ts";
import {ServiceTag} from "@/lib/types/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

interface TagsActionDeleteProps {
  tag: ServiceTag;
}

export const TagsActionDelete = ({tag}: TagsActionDeleteProps) => {
  const [show, setShow] = useState<boolean>(false);
  const [deleteTags, {loading}] = useMutation<GraphQLResponse<null>>(GQL_DELETE_TAGS, {
    refetchQueries: [GQL_SERVICE_TAGS],
  });

  const handleSubmit = async () => {
    const response = await deleteTags({
      variables: {
        ids: [tag.id],
      },
    });

    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  return (
    <>
      <ButtonAction tooltip="Delete Tag" onClick={() => setShow(true)}>
        <FiTrash2 />
      </ButtonAction>

      <DeleteActionDialog
        show={show}
        loading={loading}
        title="Delete Tag"
        onConfirm={handleSubmit}
        onCancel={() => setShow(false)}
      >
        <div className="row mb-4">
          <div className="col">Are you sure you want to delete "{tag.tag}"?</div>
        </div>
      </DeleteActionDialog>
    </>
  );
};
